import React from 'react';
import { useHyruleAuth, useHyruleNav } from '../hooks/HyruleHooks';
import BaseHyruleApplication from './BaseHyruleApplication';
const HyruleApplication = _ref => {
  let {
    authTokenCallback,
    tabs,
    routes,
    userConfig,
    appName,
    defaultPath,
    navHeaderCustom,
    logoutCustom,
    loadingCustom,
    userDropDownItems,
    dropDownMenus
  } = _ref;
  const authState = useHyruleAuth(authTokenCallback);
  const {
    tabs: menuTabs,
    routes: allRoutes,
    configComponent
  } = useHyruleNav(tabs, routes, userConfig);
  return /*#__PURE__*/React.createElement(BaseHyruleApplication, {
    authState: authState,
    tabs: menuTabs,
    routes: allRoutes,
    appName: appName,
    defaultPath: defaultPath,
    userConfig: configComponent,
    navHeaderCustom: navHeaderCustom,
    logoutCustom: logoutCustom,
    loadingCustom: loadingCustom,
    userDropDownItems: userDropDownItems,
    dropDownMenus: dropDownMenus
  });
};
export default HyruleApplication;